<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="800">
    <template v-slot:title>{{ title }}</template>
    <v-row>
      <v-col>
        <v-text-field
          label="Name"
          v-model="name"
          :outlined="outlinedInputs"
          hide-details
        />
      </v-col>
      <v-col>
        <v-text-field
          :readonly="codeIsReadOnly"
          label="Code"
          v-model="code"
          :outlined="outlinedInputs"
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          label="Min Stay"
          min="0"
          type="number"
          hide-details
          v-model:number="minStay"
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col>
        <v-text-field
          label="Max Stay"
          min="0"
          type="number"
          hide-details
          v-model:number="maxStay"
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col>
        <v-text-field
          label="Min Pax"
          min="0"
          type="number"
          hide-details
          v-model:number="minPax"
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col>
        <v-text-field
          label="Max Pax"
          min="0"
          type="number"
          hide-details
          v-model:number="maxPax"
          :outlined="outlinedInputs"
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <v-checkbox
          label="Inc Pax"
          v-model="includePax"
          :disabled="includeQuantity"
          hide-details
        />
      </v-col>
      <v-col class="py-0">
        <v-checkbox label="Inc Days" v-model="includeDays" />
      </v-col>
      <v-col class="py-0">
        <v-checkbox
          label="Inc Quantity"
          v-model="includeQuantity"
          :disabled="includePax"
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-switch label="Not in Use" v-model="notInUse" />
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <div v-if="debug">
      <code>{{ value }}==={{ notInUse }} </code>
    </div>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
export default {
  name: "rate-type-edit-dialog",

  components: { BasicDialog },

  props: {
    value: {
      type: Object,
      default: () => null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      debug: false,
      name: this.value ? this.value.name : "New Rate Type",
      code: this.value ? this.value.code : "",
      includePax: this.value ? this.value.includePax : false,
      includeDays: this.value ? this.value.includeDays : false,
      includeQuantity: this.value ? this.value.includeQuantity : false,
      maxPax: this.value ? this.value.maxPax : null,
      minPax: this.value ? this.value.minPax : null,
      minStay: this.value ? this.value.minStay : null,
      maxStay: this.value ? this.value.maxStay : null,
      notInUse: this.value ? this.value.notInUse : false,
    };
  },

  computed: {
    codeIsReadOnly() {
      return this.value && this.value.id ? true : false;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    title() {
      return this.value && this.value.id ? this.name : "New Rate Type";
    },
    isValid() {
      return this.name && this.name != "" && this.code && this.code != "";
    },
  },

  watch: {
    value(newVal) {
      this.name = newVal.name;
      this.code = newVal.code;
      this.includePax =
        newVal.includePax && newVal.includePax.toString() == "true";
      this.includeDays =
        newVal.includeDays && newVal.includeDays.toString() == "true";
      this.includeQuantity =
        newVal.includeQuantity && newVal.includeQuantity.toString() == "true";
      this.maxPax = newVal.maxPax;
      this.minPax = newVal.minPax;
      this.minStay = newVal.minStay;
      this.maxStay = newVal.maxStay;
      this.notInUse =
        newVal.notInUse && newVal.notInUse.toString() == "true" ? true : false;
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        id: this.value && this.value.id ? this.value.id : undefined,
        name: this.name,
        code: this.code,
        includePax: this.includePax && this.includePax.toString() == "true",
        includeDays: this.includeDays && this.includeDays.toString() == "true",
        includeQuantity:
          this.includeQuantity && this.includeQuantity.toString() == "true",
        maxPax: parseInt(this.maxPax),
        minPax: parseInt(this.minPax),
        minStay: parseInt(this.minStay),
        maxStay: parseInt(this.maxStay),
        notInUse:
          this.notInUse && this.notInUse.toString() == "true" ? true : false,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/department-types/RateTypeEditDialog.vue